// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Lq-z","breadcrumbForward":"Mq-z","breadcrumbBack":"Nq-z","selected":"Oq-z"};